import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortComponent } from './sort.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    SortComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    SortComponent
  ]
})
export class SortModule { }
